
import { Component } from 'react';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaRedirect } from '../../code/ArcaRedirect';

export class ArcaComponent extends Component {

    constructor(props) {
        super(props);
        if (typeof this.props.history !== 'undefined') {
            ArcaRedirect.History = this.props.history;
            //this.getLocation();
        }
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    //getLocation() {
    //    if (navigator.geolocation) {
    //        navigator.geolocation.getCurrentPosition((pos) => this.showPosition(pos));
    //    } else {
    //        x.innerHTML = "Geolocation is not supported by this browser.";
    //    }
    //}

    showPosition(pos) {
        //alert(pos);
    }
}
